import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from '../constants';

export default function* () {
    yield takeLatest(ACTION.CREATE_WAREHOUSE_STAFF.REQUEST, saga.createWarehouseStaff);
    yield takeLatest(ACTION.CREATE_WAREHOUSE_STAFF.SUCCESS, saga.createWarehouseStaffSuccess);
}